import { render, staticRenderFns } from "./Wp_my_child_num_income.vue?vue&type=template&id=31d33010&scoped=true&"
import script from "./Wp_my_child_num_income.vue?vue&type=script&lang=js&"
export * from "./Wp_my_child_num_income.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d33010",
  null
  
)

export default component.exports